import { Modal } from 'bootstrap'

var acceptButton = document.querySelector('#content-modal #accept');
var modalDiv = document.querySelector('#content-modal');

if (modalDiv) {
  // open modal on page load
  window.onload = () => {
    // if session variable is set, don't show modal
    if (sessionStorage.getItem(`modal-${modalDiv.dataset.guid}`) === 'true') {
      return;
    }

    let instance = Modal.getOrCreateInstance(modalDiv);
    instance.show();
  }

  if (acceptButton) {
    // accept button click event
    acceptButton.addEventListener('click', function () {
      // optionally store choice in session
      if (acceptButton.dataset.action === 'session') {
        sessionStorage.setItem(`modal-${modalDiv.dataset.guid}`, 'true');
      }

      let instance = Modal.getInstance(modalDiv);
      instance.hide();
    });
  }
}
